/**
 * SEÇÃO 8: STACK DE VALOR (ANCORAGEM)
 * 
 * Lista tudo incluso com valores para ancoragem de preço.
 * Preço final: R$97 por 1 pessoa - SEMPRE.
 */

import { memo } from "react";
import { Check, Ship, Fish, LifeBuoy, Coffee, Gift, Calendar, Trophy, ArrowRight } from "lucide-react";

const valueItems = [
  { icon: Ship, title: "Passeio de caravela 3-4h", value: "R$ 150" },
  { icon: Fish, title: "Snorkeling com equipamento completo", value: "R$ 80" },
  { icon: LifeBuoy, title: "Roupa de neoprene", value: "R$ 40" },
  { icon: Coffee, title: "Café da manhã a bordo", value: "R$ 30" },
  { icon: Gift, title: "Sorteio de brindes", value: "R$ 50+" },
  { icon: Calendar, title: "Voucher válido 12 meses", value: "Flexibilidade total" },
];

export const BlocoValorSection = memo(({ sectionRef, isVisible, onOpenPalpiteModal }) => {
  return (
    <section 
      ref={sectionRef}
      className={`py-12 md:py-16 bg-gradient-to-b from-gray-50 to-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="bloco-valor-section"
    >
      <div className="max-w-4xl mx-auto px-4">
        
        {/* Título */}
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-black text-[#002776] mb-2">
            O QUE VOCÊ ESTÁ LEVANDO
          </h2>
          <p className="text-gray-600">Valor real de tudo que está incluso</p>
        </div>
        
        {/* Lista de valor */}
        <div className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden mb-8">
          
          {valueItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <div 
                key={`value-${index}`}
                className={`flex items-center justify-between p-4 ${index !== valueItems.length - 1 ? 'border-b border-gray-100' : ''}`}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#002776]/10 flex items-center justify-center">
                    <Icon className="w-5 h-5 text-[#002776]" />
                  </div>
                  <span className="font-medium text-gray-800">{item.title}</span>
                </div>
                <span className="text-gray-400 line-through text-sm">{item.value}</span>
              </div>
            );
          })}
          
          {/* Bônus Desafio Hexa */}
          <div className="bg-[#FFDF00]/20 p-4 border-t-2 border-[#FFDF00]">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#FFDF00] flex items-center justify-center">
                  <Trophy className="w-5 h-5 text-[#002776]" />
                </div>
                <div>
                  <span className="font-bold text-[#002776]">Bônus Desafio do Hexa</span>
                  <p className="text-xs text-gray-600">Acertou = dinheiro de volta OU +1 pessoa grátis</p>
                </div>
              </div>
              <span className="text-[#009C3B] font-bold">GRÁTIS</span>
            </div>
          </div>
          
        </div>
        
        {/* Total riscado vs preço real */}
        <div className="bg-[#002776] rounded-2xl p-6 text-center text-white mb-6">
          <p className="text-white/60 text-sm mb-1">Valor total se você comprasse separado</p>
          <p className="text-2xl line-through text-white/40 mb-2">R$ 350+</p>
          <p className="text-white/80 text-sm mb-3">Tudo isso por apenas:</p>
          <p className="text-5xl md:text-6xl font-black text-[#FFDF00]">R$ 97</p>
          <p className="text-white/80 mt-2">Por 1 pessoa • ou 12x de R$ 10,03</p>
        </div>
        
        {/* CTA */}
        <div className="text-center">
          <button
            onClick={onOpenPalpiteModal}
            className="inline-flex items-center gap-2 bg-[#009C3B] hover:bg-[#007830] text-white font-black py-4 px-8 rounded-xl shadow-lg text-lg transition-all duration-300 hover:scale-105"
          >
            GARANTIR MEU PASSEIO — R$97
            <ArrowRight className="w-5 h-5" />
          </button>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-4 text-gray-500 text-xs">
            <span className="flex items-center gap-1">
              <Check className="w-3 h-3 text-[#009C3B]" /> Pagamento seguro
            </span>
            <span className="flex items-center gap-1">
              <Check className="w-3 h-3 text-[#009C3B]" /> Garantia 30 dias
            </span>
            <span className="flex items-center gap-1">
              <Check className="w-3 h-3 text-[#009C3B]" /> Voucher 12 meses
            </span>
          </div>
        </div>
        
      </div>
    </section>
  );
});

export default BlocoValorSection;
